import * as React from "react";
import CopyToClipboard from "~/components/CopyToClipboardButton/CopyToClipboardButton";
import { ThirdPartyIcon, ThirdPartyIconType } from "~/primitiveComponents/dataDisplay/Icon";
import styles from "./style.module.less";

interface ServerThumbprintProps {
    thumbprint: string;
}

class ServerThumbprint extends React.PureComponent<ServerThumbprintProps> {
    render() {
        return (
            <span className={styles.container}>
                <ThirdPartyIcon iconType={ThirdPartyIconType.Fingerprint} />
                <span className={styles.thumbprint}>{this.props.thumbprint}</span>
                <CopyToClipboard value={this.props.thumbprint} />
            </span>
        );
    }
}

export default ServerThumbprint;
